import React, { useEffect } from 'react'
import imgModalSorry from '../../../assets/images/fondoModalSorry.png'
import ButtonClose from '../../atoms/button-close/button-close'
import { siteUrl } from '../../../shared/utils/siteUrl'

import './modalSorry.scss'

import { jsonToHash } from '../../../utils/crypto'
import getUserInfo from '../../../utils/getUserInfo'
import { pushEventData } from '../../../utils/pushEventDataLayer'

import Button from '../../atoms/button/button'
import { LOCALE } from '../../../constants/activity-constants'

const arg = LOCALE === "es-AR"

const ModalSorry = ({ close }) => {
  const userInfo = getUserInfo()

  useEffect(() => {
    onDatalayer('view', 'Debes tener entre 9 y 19 años')
  }, [])

  const onDatalayer = async (action, label) => {
    pushEventData({
      event: 'Interacciones_Pop_up_UCole',
      label: label,
      action: action ? action : 'click',
      user_data: userInfo && [
        await jsonToHash({
          nombre: userInfo.name,
          apellido: userInfo.lastName,
          celular: userInfo.cellPhone,
          correo: userInfo.email,
          ciudad: userInfo.location.cityName,
          departamento: userInfo.location.countryStateName,
          pais: userInfo.countryName,
        }),
      ],
      log_status: userInfo ? 'Yes' : 'Not',
    })
  }

  return (
    <div className="f-modalSorry-container">
      <div className="f-modalSorry-container__wrapper">
        <ButtonClose onClick={close} />
        <figure className="f-modalSorry-container__figure">
          <img
            className="f-modalSorry-container__image"
            src={imgModalSorry}
            alt="fondo espacial del modal lo sentimos"
          />
        </figure>
        <section className="f-modalSorry-container__infoLogin">
          <h2>¡Lo sentimos!</h2>
          <p>
            <b>
              Para participar en esta actividad {arg ? 'debés' : 'debes'} tener entre 9 y 19 años.
            </b>
            <br /> <br />
            Te invitamos a que ingreses a{' '}
            <a
              target="_BLANK"
              href={siteUrl}
              onClick={() => onDatalayer(false, 'NosotrasOnline')}
            >
              NosotrasOnline
            </a>{' '}
            , para que disfrutes del resto de contenido que tenemos para {arg ? 'vos' : 'ti'}.
          </p>
          <Button
            onClick={() => {
              onDatalayer(false, 'Entendido')
              close()
            }}
            className="f-buttonSorry"
          >
            Entendido
          </Button>
        </section>
      </div>
    </div>
  )
}

export default ModalSorry
